module.exports = __webpack_public_path__ + "img/image.104921cb.png";